import React from 'react';
import cl from './AboutInfo.module.css';

const AboutInfo = (props) => {
    return (
        <section className={cl.about}>
          <h1>Our story</h1>
          <img className={cl.big_image} src='https://media.istockphoto.com/id/1257101256/pl/wektor/szcz%C4%99%C5%9Bliwi-ludzie-skacz%C4%85cy-%C5%9Bwi%C4%99tuj%C4%85-zwyci%C4%99stwo-p%C5%82aska-ilustracja-postaci-z-kresk%C3%B3wek.jpg?s=612x612&w=0&k=20&c=EjOeBamarQU-zkHynOaJEyeNKUQ5Kf_XUuAvX17Mnpk='/>
          <p>{props.shopStory}</p>
      </section>
    );
}

export default AboutInfo;